"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sapphireConstants = {
    SOURCE_NA: 0,
    SOURCE_MOBILE: 2,
    SOURCE_REGISTRY_KIOSK: 7
};
exports.default = sapphireConstants;
